import type { UndoableState } from "../../vendor/src/features/remotion-editor/editor/state/types";
import { splitNarrationAtMainCuts } from "../host/narration-cuts";
import {isNarrationTrack} from './narration-track';

/** Initial legacy handoff only. Reopening a native document must not re-cut user edits. */
export function alignImportedNarration(document: UndoableState): {
  document: UndoableState;
  notice?: string;
} {
  const ids = document.tracks
    .filter(isNarrationTrack)
    .flatMap((track) => track.items);
  if (!ids.length) return { document };
  const result = splitNarrationAtMainCuts(document, ids);
  if (!result.ok) {
    const detail =
      result.reason === "locked-narration"
        ? "잠긴 음성 트랙"
        : result.reason === "audio-envelope-requires-review"
          ? "음성 페이드 또는 특수 재생 설정"
          : "메인 컷과 음성의 연결";
    return {
      document,
      notice: `${detail}을 보존하기 위해 음성 자동 분할을 보류했습니다. 편집 내용은 그대로입니다.`,
    };
  }
  if (result.state === document) return { document };
  const count = ids.reduce(
    (sum, id) => sum + (result.replacements[id]?.length ?? 1),
    0,
  );
  return {
    document: result.state,
    notice: `나레이션을 메인 컷 경계에 맞춰 ${count}개 클립으로 나눴습니다. 원본 음성 파일은 그대로입니다.`,
  };
}
